import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './styles/App.css';
import { PageLayout } from './components/PageLayout';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated } from '@azure/msal-react';
import Home from './components/Home';
import LandingPage from './components/LandingPage';
import Profile from './components/Profile';
import ProtectedRoute from './components/ProtectedRoute';
import Valentines2025 from './components/Valentines2025';
import BirthdayPage from './components/BirthdayPage';
import UkraineTrip from './components/UkraineTrip';
import TikTokGenerator from './components/TikTokGenerator';

/**
 * Application component that sets up routing with authentication protection
 */
export default function App() {
    const isAuthenticated = useIsAuthenticated();

    return (
        <Router>
            <PageLayout>
                <Routes>
                    <Route path="/" element={isAuthenticated ? <Navigate to="/home" /> : <LandingPage />} />
                    
                    {/* Protected routes */}
                    <Route element={<ProtectedRoute />}>
                        <Route path="/home" element={<Home />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/valentines2025" element={<Valentines2025 />} />
                        <Route path="/birthday" element={<BirthdayPage />} />
                        <Route path="/ukraine" element={<UkraineTrip />} />
                        <Route path="/tiktok-generator" element={<TikTokGenerator />} />
                    </Route>
                    
                    {/* Fallback route */}
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </PageLayout>
        </Router>
    );
}
